import React, { useRef, createRef } from "react";
import classNames from 'classnames/bind'
import PropTypes from 'prop-types';
import StatementAttachmentItem from '@mpc/common/src/features/StatementAttachmentItem';
import { TabContent } from 'containers/SmWorkbench/ProjectDetail/Show/Detail/Bottom/components';
import { Alert, Button } from "@bedrock/components";
import { Check } from "@bedrock/icons-react";
import "./index.less"
import { outsourceDemandMoveMove } from "services/api";


type State = {
    loading: boolean,
    statementAttachmenValue: {
        invoice_belong_area: undefined,
        is_oversea_invoice: undefined,
        invoice_list: [],
        signed_statement_attachs: [],
    }
}

class Index extends React.Component<any> {
    ref = createRef<any>()
    public static contextTypes = {
        detail: PropTypes.any,
        loadDetail: PropTypes.func,
        projectMove: PropTypes.func,
    };
    state: State = {
        loading: false,
        statementAttachmenValue: {
            invoice_belong_area: undefined,
            is_oversea_invoice: undefined,
            invoice_list: [],
            signed_statement_attachs: [],
        }

    }
    constructor(props: any) {
        super(props)
    }

    componentDidMount() {
        const { detail } = this.context
        this.setState({
            statementAttachmenValue: {
                signed_statement_attachs: detail?.signed_statement_attachs
            },
        })
    }

    handleSubmit = async () => {
        const { detail, loadDetail } = this.context;
        const data = await this.ref.current?.validateFields()
        const {
            signed_statement_attachs = [],
            invoice_belong_area,
            is_oversea_invoice,
            invoice_list
        } = data
        const signed_statement_attachs_blob_keys = signed_statement_attachs?.map((item: any) => item?.blob?.key)
        this.setState({ loading: true })
        outsourceDemandMoveMove({
            id: detail.id,
            state: detail.state,
            pass: true,
            form: {
                signed_statement_attachs_blob_keys,
                invoice_upload_dto: {
                    invoice_belong_area,
                    is_oversea_invoice,
                    invoice_list,
                }
            }
        }).then((result: any) => {
            if (result.code === 1) {
                loadDetail()
            }
        }).finally(() => {
            this.setState({ loading: false })
        })
    }
    renderBottom = () => {
        const { loading } = this.state
        return (
            <div className="button-container">
                <Button loading={loading} type="primary" icon={<Check />} onClick={this.handleSubmit}>提交</Button>
            </div>
        );
    }
    render() {
        const { statementAttachmenValue } = this.state
        const { detail = {} } = this.context
        return (
            <TabContent canScroll={true} bottom={this.renderBottom()} tabKey={this.props?.tabKey} className="bottom-space">
                {detail?.return_flag && <Alert
                    message='上传发票退回'
                    description={`退回原因：${detail?.return_reason || '--'}`}
                    type='warning'
                    showIcon
                    style={{ margin: `0 0 20px` }}
                />}
                <Alert
                    message='请确保提供与支付款项等额发票，超额开具部分，网易将不予受理退回款申请，亦不可用于抵扣合作尾款或其他合作款项。'
                    type='warning'
                    showIcon
                    style={{ margin: `0 0 20px` }}
                />
                {!detail?.demand_suppliers?.[0]?.inner_supplier &&
                    <StatementAttachmentItem
                        onChange={value => {
                            this.setState({ statementAttachmenValue: value })
                        }}
                        value={statementAttachmenValue}
                        detail={detail}
                        ref={this.ref}
                    />}
            </TabContent>
        )
    }
}

export default Index;